import type { TimerBlockData } from '@/components/canvas/blocks/types';

const DEFAULT_CONTENT_SIZE = 220;

export function estimateTimerContentSize(data: TimerBlockData): {
  width: number;
  height: number;
} {
  const size = data.size ?? DEFAULT_CONTENT_SIZE;
  return { width: size, height: size };
}
